import React from 'react';
import Gif404 from '../../media/gif404.gif';
import { useTranslation } from 'react-i18next';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';

const PageNotFound: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Stack textAlign="center" justifyContent="space-evenly" padding={8}>
      <span>
        <Typography>{t('error-page-not-found')}</Typography>
        <img alt="" src={Gif404} style={{ maxWidth: '75%', maxHeight: '50%' }} />
      </span>
    </Stack>
  );
};

export default PageNotFound;
